import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentUser } from 'src/app/core/models';
import { AuthService } from 'src/app/core/services/auth.service';
import { ThemeService, ThemeMode } from 'src/app/core/services/theme.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  readonly currentUser$ = this.authService.currentUser$;
  readonly theme$ = this.themeService.theme$;

  menuOpen = false;

  constructor(
    private readonly authService: AuthService,
    private readonly themeService: ThemeService,
    private readonly router: Router
  ) {}

  toggleTheme(): void {
    this.themeService.toggle();
  }

  isDark(theme: ThemeMode): boolean {
    return theme === 'dark';
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  initials(user: CurrentUser | null): string {
    if (!user?.fullName) return '?';
    const parts = user.fullName.trim().split(/\s+/);
    return parts.slice(0, 2).map((p) => p[0]?.toUpperCase() ?? '').join('');
  }
}
